// extracted by mini-css-extract-plugin
module.exports = {"speakerWrap":"SpeakerList_speakerWrap__2OtX3","header":"SpeakerList_header__3thas","title":"SpeakerList_title__11_fP","horizontal":"SpeakerList_horizontal__uQ_iR"};